import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestSearch = ({ csrfToken, page = 1, postParams }) => {
  const result = apiClient.post(
    `/user/purchase_list/search/${page}`,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestHistoryList = ({ page = 1 }) => {
  const result = apiClient.get(
    `/user/purchase_list/history/list/${page}`,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestSave = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/purchase_list/save',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestHistoryDetail = ({ historyId }) => {
  const result = apiClient.get(
    `/user/purchase_list/history/detail/${historyId}`,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestSearch,
  requestHistoryList,
  requestSave,
  requestHistoryDetail,
};
